import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import { useSearchParams } from 'react-router-dom';
import { useFetch } from '../hook/useFecth';
import ClientesListLayer from '../components/ClientesListLayer';

const ClientesListPage = () => {
    const [searchParams] = useSearchParams();
    const { data } = useFetch(`/cliente`, { params: { ...Object.fromEntries([...searchParams]) } });
    return (
        <>
            {/* Breadcrumb */}
            <Breadcrumb title="Clientes" icon="solar:user-id-outline" />

            {/* UsersListLayer */}
            <ClientesListLayer data={data} />
        </>
    );
};

export default ClientesListPage;
